<template>
    <a class="u-reset link link__icon link__no-underline" :href="link.path">
        {{ link.label }}
        <base-icon class="link--icon" symbol="arrow-right" size="small"/>
    </a>
</template>

<script>
    export default {
        props: {
            link: {
                type: Object,
                required: true,
            },
        },
    };
</script>
